<template>
  <div class="code-unauth-setting" v-if="is_as_custom">
    <p class="mb-0 mt-8 title font-weight-bold">코드 미인증 상품 설정</p>
    <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
      시리얼 코드 입력 없이 정품 인증을 진행해야 하는 경우 상품이 있는 경우 사용합니다. <br />
      카페24 상품을 조회하여 미인증 받을 상품을 설정해 주세요. <br />
      고객은 쇼핑몰에서 정품 인증시 인증 코드를 생성한 상품과 미인증 설정된 상품을 선택할 수 있으며, <br />
      미인증으로 설정한 상품은 시리얼 코드 입력 없이 정품 인증을 받을 수 있습니다.
    </p>

    <v-row class="mt-3">
      <v-col cols="6">
        <v-card-subtitle class="pb-0 font-weight-bold pl-0 mb-2 black--text">
          카페24 상품 조회/선택
        </v-card-subtitle>
        <div class="d-flex justify-space-between">
          <v-select
            v-model="searchPayload.search_type"
            :items="search_type_list"
            outlined
            dense
            hide-details="false"
            hint="상품을 선택해주세요."
            class="mr-2"
          ></v-select>
          <v-text-field
            v-model="searchPayload.search_value"
            outlined
            dense
            hide-details="false"
            class="mr-2"
            @keypress.enter="searchProduct"
            placeholder="검색어 입력"
          ></v-text-field>
          <v-btn color="grey darken-4" height="40px" class="white--text" @click="searchProduct">조회</v-btn>
        </div>
        <div class="rounded-lg mt-4 product_list py-0">
          <v-list dense class="py-0">
            <v-list-item class="d-flex justify-space-between text-center list-border-bottom">
              <v-list-item-title :style="{ width: '80%' }" class="table-title">상품 정보</v-list-item-title>
              <v-list-item-title :style="{ width: '20%' }" class="table-title"> 선택 </v-list-item-title>
            </v-list-item>
            <v-list-item v-for="(item, index) in search_product_list" :key="index" class="d-flex justify-space-between list-border-bottom">
              <v-list-item-avatar rounded="false">
                <v-img v-if="item.list_image" :src="item.list_image" width="40" height="40"></v-img>
                <v-img v-else :src="adminDefaultImg" width="40" height="40"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  [{{ item.product_code }}] {{ item.product_name }}<br />
                  판매가 : {{ item.product_price | numberFormat }}원
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="blue darken-1" class="white--text" small @click="addSelectProduct(item.product_code)">
                  설정
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </v-col>
      <v-col cols="6">
        <v-card-subtitle class="pb-2 font-weight-bold black--text pl-0">설정 상품 목록</v-card-subtitle>
        <div class="d-flex justify-space-between align-center" :style="{ height: '40px' }">
          <span>
            총 설정 <span class="blue--text">{{ selected_product_list.length }}</span> 개
          </span>
          <v-btn color="blue-grey darken-3" class="white--text" small @click="unselectAllProduct">전체삭제</v-btn>
        </div>
        <div class="rounded-lg mt-4 product_list">
          <v-list dense class="py-0">
            <v-list-item class="text-center list-border-bottom">
              <v-list-item-title :style="{ width: '80%' }" class="table-title">상품 정보</v-list-item-title>
              <v-list-item-title :style="{ width: '20%' }" class="table-title"> 삭제 </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-for="(item, index) in selected_product_list"
              :key="index"
              class="d-flex justify-space-between list-border-bottom"
            >
              <v-list-item-avatar rounded="false">
                <v-img v-if="item.product_image" :src="item.product_image" width="40" height="40"></v-img>
                <v-img v-else :src="adminDefaultImg" width="40" height="40"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  [{{ item.product_code }}] {{ item.product_name }}<br />
                  판매가 : {{ item.product_price | numberFormat }}원
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="grey darken-1" class="white--text" small @click="removeSelectProduct(item.product_code)">
                  삭제
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </v-col>
    </v-row>

    <div class="d-flex justify-center mt-8">
      <v-btn large color="primary" class="white--text" width="200" @click="saveSetting">저장</v-btn>
    </div>
  </div>
</template>

<style scoped>
.code-unauth-setting .product_list {
  height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.code-unauth-setting .product_list .v-list-item {
  flex: auto;
}

.code-unauth-setting .product_list .v-avatar {
  border-radius: 2px;
}

.code-unauth-setting .list-border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

.code-unauth-setting label {
  font-size: unset !important;
}
</style>

<script>
import M from "@/libs/mapping.js";
import Filters from "@/libs/authservice/filters.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      is_as_custom: false,
      search_type_list: [
        { text: "상품명", value: "product_name" },
        { text: "상품코드", value: "product_code" },
      ],
      searchPayload: {
        search_type: "product_name",
        search_value: "",
      },
      search_product_list: [],
      selected_product_list: [],
      adminDefaultImg: require("@/assets/authservice/images/admin_default.png"),
    };
  },
  created() {
    this.is_as_custom = M.isCustomCheck() === "as_custom";
    if (this.is_as_custom) {
      this.getConfigUnauthProduct();
    }
  },
  mixins: [CommonMixin],
  methods: {
    async getConfigUnauthProduct() {
      try {
        const data = await M.api(M.entry("/get/config/unauth/product"));
        if (data) {
          this.selected_product_list = data.product_list || [];
        }
      } catch (error) {
        console.log(error);
        /*
        if (confirm("테스트 데이터 셋팅해서 볼래?")) {
          const sampleData = {
            count: 2,
            product_list: [
              {
                product_name: "샘플상품 2",
                product_code: "P000000J",
                product_no: 10,
                product_price: 10000,
                custom_product_code: null,
                list_image: "https://surping1.cafe24.com/web/product/medium/201508/10_shop1_528500.jpg",
                product_image: "https://surping1.cafe24.com/web/product/medium/201508/10_shop1_528500.jpg",
              },
              {
                product_name: "샘플상품 4",
                product_code: "P000000L",
                product_no: 12,
                product_price: 20000,
                custom_product_code: null,
                list_image: "https://surping1.cafe24.com/web/product/medium/201508/12_shop1_448905.jpg",
                product_image: "https://surping1.cafe24.com/web/product/medium/201508/12_shop1_448905.jpg",
              },
            ],
          };
          this.selected_product_list = sampleData.product_list;
        }
          */
      }
    },
    addSelectProduct(product_code) {
      const select_item = this.search_product_list.find((item) => item.product_code == product_code);
      if (!select_item) {
        return;
      }
      this.selected_product_list.push({
        ...select_item,
        product_image: select_item.list_image,
      });
      this.search_product_list = this.search_product_list.filter((item) => item.product_code != product_code);
      this.alertShow(product_code + "선택한 상품을 선택하였습니다.");
    },
    removeSelectProduct(product_code) {
      this.selected_product_list = this.selected_product_list.filter((item) => item.product_code != product_code);
    },
    async getProductList(payload) {
      let data = await M.api(M.entry("/get/search/product"), payload);
      this.search_product_list =
        data
          .map((item) => ({
            ...item,
            product_name: item.product_name.replace(/<\/?[^>]+(>|$)/g, ""),
          }))
          .filter((item) => !this.selected_product_list.some((selected) => selected.product_code === item.product_code)) || [];
      this.defaultProgressHide();
    },
    searchProduct() {
      if (!this.is_as_custom) {
        return;
      }
      if (this.searchPayload.search_type === "product_name" && this.searchPayload.search_value.length < 2) {
        this.alertShow("상품명은 2글자 이상부터 검색이 가능합니다.");
        return;
      }
      this.defaultProgressShow();
      this.getProductList(this.searchPayload);
    },
    unselectAllProduct() {
      if (confirm("설정하신 상품 목록을 전체 삭제 하시겠습니까?")) {
        this.selected_product_list = [];
      }
    },
    async saveSetting() {
      if (!this.is_as_custom) {
        return;
      }
      try {
        const res = await M.api(M.entry("/put/config/unauth/product"), {
          product_list: this.selected_product_list,
        });
        console.log("set unauth product result", res);
        this.alertShow("설정이 저장되었습니다.");
      } catch (error) {
        console.log(error);
        this.alertShow("설정 저장에 실패하였습니다.");
      }
    },
  },
  filters: Filters,
};
</script>
